import tldData from '../data/tlds.json';

// Extract all TLDs from the JSON data and make it a readonly array
export const TLD_VALUES = Object.freeze(
  tldData.map((entry) => entry.tld)
) as readonly string[];

// Most commonly used TLDs for default suggestions (reduced to 5)
export const DEFAULT_TLDS = ['.com', '.net', '.org', '.io', '.co'] as const;

// Type for any valid TLD
export type Tld = (typeof DEFAULT_TLDS)[number] | (typeof TLD_VALUES)[number];

// Export the full TLD data for additional information if needed
export interface TldInfo {
  tld: string;
  type: string;
  manager: string;
}

export const getTldInfo = (tld: string): TldInfo | undefined => {
  return tldData.find((entry) => entry.tld === tld);
};
